import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"],\"variable\":\"--font-inter\"}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/nextjs-toploader/dist/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["SettingsProvider"] */ "/vercel/path0/src/components/providers/SettingsProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SupabaseAuthProvider"] */ "/vercel/path0/src/components/providers/SupabaseAuthProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ToastProvider"] */ "/vercel/path0/src/components/providers/ToastProvider.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/styles/index.css");
